import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';

const SelectField = ({ field, fieldTitles, formData, handleInputChange, options }) => (
    <FormControl fullWidth>
      <InputLabel htmlFor={`${field}-select`} id={`${field}-label`}>{fieldTitles[field]?.title}</InputLabel>
      <Select
        labelId={`${field}-label`}
        name={field}
        value={formData[field]}
        onChange={handleInputChange}
        label={`${fieldTitles[field].title} *`}
        inputProps={{
          id: `${field}-select`,
        }}
      >
        {options.map((option, index) => (
          <MenuItem key={index} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );

  export default SelectField